import React from 'react'
import RichContent from '../rich-content'

const Block = ({ content, className }) => <RichContent className={className} content={content} />

export default Block
